import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { HubTopicsSectionProps } from "@/types/help-hub/presentation";
import { hubBrandTheme, inkOn, tint } from "../brandInk";
import { HubSection } from "./HubSection";

/** Topic navigation is built exclusively from the hub's published guide groups. */
export const HubTopicsSection = ({ topics, branding, urlName, onAsk }: HubTopicsSectionProps) => {
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const published = topics.filter(topic => topic.guides.length > 0);
  if (published.length < 2) return null;
  const selected = published.find(topic => topic.id === selectedId) ?? published[0];
  const theme = hubBrandTheme(branding);

  return (
    <HubSection id="help-topics" title="Find help by topic" subtitle="Choose what you need a hand with. We’ll go from there." genieIcon="globe" branding={branding}>
      <div className="hub-topics-layout">
        <div className="hub-topic-choices" aria-label="Support topics">
          {published.map((topic, index) => <button key={topic.id} type="button" aria-pressed={selected.id === topic.id} aria-controls="hub-topic-content" onClick={() => setSelectedId(topic.id)} style={selected.id === topic.id ? { borderColor: theme.primary, background: tint(theme.primary, 0.06) } : undefined}><span>{String(index + 1).padStart(2, "0")}</span><span>{topic.name}</span><ArrowRight className="h-4 w-4 shrink-0" /></button>)}
        </div>
        <div id="hub-topic-content" className="hub-topic-content" aria-live="polite">
          <p className="hub-card-eyebrow">LET’S FIND THE RIGHT HELP</p>
          <h3>{selected.name}</h3>
          <p>{selected.guides.length} published {selected.guides.length === 1 ? "guide" : "guides"} to explore, or ask the Genie directly.</p>
          <div className="hub-topic-guides">{selected.guides.slice(0, 3).map(guide => <Link key={guide.id} to={`/help/${encodeURIComponent(urlName)}/${encodeURIComponent(guide.id)}`}><span>{guide.name}</span><ArrowRight className="h-4 w-4 shrink-0" /></Link>)}</div>
          <button type="button" onClick={() => onAsk(`I need help with ${selected.name}.`)} className="hub-support-button" style={{ background: theme.gradient, color: inkOn(theme.primary) }}>Ask about this topic <ArrowRight className="h-4 w-4" /></button>
        </div>
      </div>
    </HubSection>
  );
};
